import { render, staticRenderFns } from "./paint-bord.vue?vue&type=template&id=03d3d2c7&scoped=true"
import script from "./paint-bord.vue?vue&type=script&lang=js"
export * from "./paint-bord.vue?vue&type=script&lang=js"
import style0 from "./paint-bord.vue?vue&type=style&index=0&id=03d3d2c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d3d2c7",
  null
  
)

export default component.exports